import React, { useRef, useState } from 'react'
import { Input } from 'antd'

import * as CSS from './styles'
import { useTranslation } from 'react-i18next'

type Props = {
  initialValues: string
  onChange(values: string): void
}

export default function RequestTitleFilter({
  initialValues = '',
  onChange
}: Props) {
  const refTimeout = useRef<NodeJS.Timeout>(null)
  const { t } = useTranslation()

  const [value, setValue] = useState<string>(initialValues)

  return (
    <CSS.Content>
      <Input
        allowClear
        data-test-id="request-title-filter"
        defaultValue={initialValues}
        onChange={({ target: { value = '' } }) => {
          setValue(value)
          if (value.length > 0 && value.length < 3) {
            return
          }
          clearTimeout(refTimeout.current)
          refTimeout.current = setTimeout(() => {
            onChange(value)
          }, 1000)
        }}
        placeholder={t('common.request-title-filter')}
        value={value}
      />
    </CSS.Content>
  )
}
